import { defineMessages } from 'react-intl';
const i18nKey = 'Footer.Navigation';
const messages = defineMessages({
  home: {
    id: `${i18nKey}.home`,
    defaultMessage: 'Home',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Navigation link for home page (CharLimit autocalculated to 35)`
  },
  signUp: {
    id: `${i18nKey}.signup`,
    defaultMessage: 'Get started',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link for sign up (CharLimit autocalculated to 45)`
  },
  getStarted: {
    id: `${i18nKey}.getStarted`,
    defaultMessage: 'Get started',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link for sign up to get started (CharLimit autocalculated to 45)`
  },
  signin: {
    id: `${i18nKey}.signin`,
    defaultMessage: 'Sign in',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link for sign in (CharLimit autocalculated to 40)`
  },
  login: {
    id: `${i18nKey}.login`,
    defaultMessage: 'Log in',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link for log in (CharLimit autocalculated to 40)`
  },
  products: {
    id: `${i18nKey}.products`,
    defaultMessage: 'Products',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation header on home page for links to all Coinbase products (CharLimit autocalculated to 40)`
  },
  prices: {
    id: `${i18nKey}.prices`,
    defaultMessage: 'Prices',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link on home page for cryptocurrency prices (CharLimit autocalculated to 40)`
  },
  learn: {
    id: `${i18nKey}.learn`,
    defaultMessage: 'Learn',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Navigation header on home page for links to learn more about crypto (CharLimit autocalculated to 35)`
  },
  individuals: {
    id: `${i18nKey}.individuals`,
    defaultMessage: 'Individuals',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Header of a group of links to various resources about products for individuals (CharLimit autocalculated to 45)`
  },
  businesses: {
    id: `${i18nKey}.businesses`,
    defaultMessage: 'Businesses',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Header of a group of links to various resources about products for businesses (CharLimit autocalculated to 45)`
  },
  developers: {
    id: `${i18nKey}.developers`,
    defaultMessage: 'Developers',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Header of a group of links to various resources about services for Developers (CharLimit autocalculated to 45)`
  },
  institutions: {
    id: `${i18nKey}.institutions`,
    defaultMessage: 'Institutions',
    description: `
    #Component: TextHeadline
    #CharLimit: 45
    #Context: Header of a group of links to various resources about products for institutions`
  },
  // 2023-10-05: TODO please fix, see go/i18n-linter-messages
  // eslint-disable-next-line @cbhq/i18n-enhanced-description
  buy: {
    id: `${i18nKey}.buy`,
    defaultMessage: 'Buy {currency}',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for buying a cryptocurrency (CharLimit autocalculated to 50)`
  },
  supportedCountries: {
    id: `${i18nKey}.supportedCountries`,
    defaultMessage: 'Supported countries',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Navigation link on home page for looking at what countries Coinbase supports (CharLimit autocalculated to 55)`
  },
  status: {
    id: `${i18nKey}.status`,
    defaultMessage: 'Status',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link on home page for looking at status of Coinbase website (CharLimit autocalculated to 40)`
  },
  jpNews: {
    id: `${i18nKey}.jpNews`,
    defaultMessage: 'News',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Navigation link on home page for Japan only news page (CharLimit autocalculated to 35)`
  },
  taxes: {
    id: `${i18nKey}.taxes`,
    defaultMessage: 'Taxes',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Navigation link on home page to Coinbase taxes page (CharLimit autocalculated to 35)`
  },
  company: {
    id: `${i18nKey}.company`,
    defaultMessage: 'Company',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation header on home page for links about Coinbase (CharLimit autocalculated to 40)`
  },
  companyDescription: {
    id: `${i18nKey}.companyDescription`,
    defaultMessage: 'Company Description',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Navigation link on home page for Coinbase KK company description (CharLimit autocalculated to 55)`
  },
  about: {
    id: `${i18nKey}.about`,
    defaultMessage: 'About',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Navigation link on home page for about Coinbase company (CharLimit autocalculated to 35)`
  },
  affiliates: {
    id: `${i18nKey}.affiliates`,
    defaultMessage: 'Affiliates',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link on home page for Affiliates at Coinbase (CharLimit autocalculated to 45)`
  },
  careers: {
    id: `${i18nKey}.careers`,
    defaultMessage: 'Careers',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link on home page for about careers at Coinbase (CharLimit autocalculated to 40)`
  },
  partners: {
    id: `${i18nKey}.partners`,
    defaultMessage: 'Partners',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link on home page for Partners (CharLimit autocalculated to 40)`
  },
  press: {
    id: `${i18nKey}.press`,
    defaultMessage: 'Press',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Navigation link on home page for Coinbase press (CharLimit autocalculated to 35)`
  },
  investors: {
    id: `${i18nKey}.investors`,
    defaultMessage: 'Investors',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link on home page for Investors informational page (CharLimit autocalculated to 40)`
  },
  legalPrivacy: {
    id: `${i18nKey}.legalPrivacy`,
    defaultMessage: 'Legal & privacy',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for about legal and privacy at Coinbase (CharLimit autocalculated to 50)`
  },
  cookiePolicy: {
    id: `${i18nKey}.cookiePolicy`,
    defaultMessage: 'Cookie policy',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link on home page for Coinbase cookie policy (CharLimit autocalculated to 45)`
  },
  modernSlaveryStatement: {
    id: `${i18nKey}.modernSlaveryStatement`,
    defaultMessage: 'UK Modern Slavery Statement',
    description: `
    #Component: LEGACY
    #CharLimit: 65
    #Context: Navigation link on home page for UK Modern Slavery Statement (CharLimit autocalculated to 65)`
  },
  imprint: {
    id: `${i18nKey}.imprint`,
    defaultMessage: 'Imprint',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link on home page for German Imprint (CharLimit autocalculated to 40)`
  },
  support: {
    id: `${i18nKey}.support`,
    defaultMessage: 'Support',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation header on home page for links about Coinbase support (CharLimit autocalculated to 40)`
  },
  helpCenter: {
    id: `${i18nKey}.helpCenter`,
    defaultMessage: 'Help center',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link on home page for Coinbase help center (CharLimit autocalculated to 45)`
  },
  contactUs: {
    id: `${i18nKey}.contactUs`,
    defaultMessage: 'Contact us',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link on home page for contacting Coinbase (CharLimit autocalculated to 45)`
  },
  createAccount: {
    id: `${i18nKey}.createAccount`,
    defaultMessage: 'Create account',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for Coinbase support article for creating an account (CharLimit autocalculated to 50)`
  },
  idVerification: {
    id: `${i18nKey}.idVerification`,
    defaultMessage: 'ID verification',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for Coinbase support article for identity verification (CharLimit autocalculated to 50)`
  },
  accountInformation: {
    id: `${i18nKey}.accountInformation`,
    defaultMessage: 'Account information',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Navigation link on home page for Coinbase support article for account information (CharLimit autocalculated to 55)`
  },
  paymentMethods: {
    id: `${i18nKey}.paymentMethods`,
    defaultMessage: 'Payment methods',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for Coinbase support article for payment methods (CharLimit autocalculated to 50)`
  },
  accountAccess: {
    id: `${i18nKey}.accountAccess`,
    defaultMessage: 'Account access',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for Coinbase support article for account recovery (CharLimit autocalculated to 50)`
  },
  sendReceiveCrypto: {
    id: `${i18nKey}.sendReceiveCrypto`,
    defaultMessage: 'Send/Receive crypto',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Navigation link on home page for Coinbase support article for sending or receiving crypto (CharLimit autocalculated to 55)`
  },
  supportedCrypto: {
    id: `${i18nKey}.supportedCrypto`,
    defaultMessage: 'Supported crypto',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for Coinbase support article for supported cryptocurrencies (CharLimit autocalculated to 50)`
  },
  pricingAndFees: {
    id: `${i18nKey}.pricingAndFees`,
    defaultMessage: 'Pricing and fees',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Navigation link on home page for Coinbase support article for pricing and fees (CharLimit autocalculated to 50)`
  },
  social: {
    id: `${i18nKey}.social`,
    defaultMessage: 'Social',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation header on home page for social media links (CharLimit autocalculated to 40)`
  },
  blog: {
    id: `${i18nKey}.blog`,
    defaultMessage: 'Blog',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Navigation link on home page for Coinbase blog (CharLimit autocalculated to 35)`
  },
  security: {
    id: `${i18nKey}.security`,
    defaultMessage: 'Security',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link on home page for Coinbase Security (CharLimit autocalculated to 40)`
  },
  earnCrypto: {
    id: `${i18nKey}.earnCrypto`,
    defaultMessage: 'Earn crypto',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link on home page for earning crypto (CharLimit autocalculated to 45)`
  },
  // 2023-10-05: TODO please fix, see go/i18n-linter-messages
  // eslint-disable-next-line @cbhq/i18n-enhanced-description
  earnGetAmount: {
    id: `${i18nKey}.earnGetAmount`,
    defaultMessage: 'Get {amount}+',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Used in a tag which would look like: Get $150+ (CharLimit autocalculated to 45)`
  },
  // 2023-10-05: TODO please fix, see go/i18n-linter-messages
  // eslint-disable-next-line @cbhq/i18n-enhanced-description
  compactEarnGetAmount: {
    id: `${i18nKey}.compactEarnGetAmount`,
    defaultMessage: '{amount}+',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Used in a tag which would look like: $150+ (CharLimit autocalculated to 40)`
  },
  cryptoOverview: {
    id: `${i18nKey}.cryptoOverview`,
    defaultMessage: 'Overview of crypto',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Link to a document that provides an overview of what crypto is (CharLimit autocalculated to 55)`
  },
  feesDisclosure: {
    id: `${i18nKey}.feesDisclosure`,
    defaultMessage: 'Fees disclosure',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Link to a document that provides a disclosure about the fees that a customer will experience when buying, selling, etc (CharLimit autocalculated to 50)`
  },
  disclosures: {
    id: `${i18nKey}.disclosures`,
    defaultMessage: 'Disclosures',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Header of a group of links to various disclosure documents, including "risks related to cryptocurrency" (CharLimit autocalculated to 45)`
  },
  risks: {
    id: `${i18nKey}.risks`,
    defaultMessage: 'Risks related to cryptocurrency',
    description: `
    #Component: LEGACY
    #CharLimit: 70
    #Context: Link to a document that describes risks associated with cryptocurrency (CharLimit autocalculated to 70)`
  },
  complaints: {
    id: `${i18nKey}.complaints`,
    defaultMessage: 'Complaints handling procedure',
    description: `
    #Component: LEGACY
    #CharLimit: 70
    #Context: Link to a document that describes how customer complaints are handled (CharLimit autocalculated to 70)`
  },
  blockchainForks: {
    id: `${i18nKey}.blockchainForks`,
    defaultMessage: 'Blockchain forks',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Link to a document that explains how blockchain forks work (CharLimit autocalculated to 50)`
  },
  foreignExchange: {
    id: `${i18nKey}.foreignExchange`,
    defaultMessage: 'Foreign Exchange and Trade Acts',
    description: `
    #Component: LEGACY
    #CharLimit: 70
    #Context: Link to a document that provides disclosures for the japanese foreign exchange and trade acts (CharLimit autocalculated to 70)`
  },
  securityMeasures: {
    id: `${i18nKey}.securityMeasures`,
    defaultMessage: 'Security measures to protect user’s assets',
    description: `
    #Component: LEGACY
    #CharLimit: 85
    #Context: Link to a document that informs users about the security measures the company takes to secure their assets (CharLimit autocalculated to 85)`
  },
  language: {
    id: `${i18nKey}.language`,
    defaultMessage: 'Language selector',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Field for selecting user language (CharLimit autocalculated to 55)`
  },
  prime: {
    id: `${i18nKey}.prime`,
    defaultMessage: 'Prime',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Prime product label (CharLimit autocalculated to 35)`
  },
  commerce: {
    id: `${i18nKey}.commerce`,
    defaultMessage: 'Commerce',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Commerce product label (CharLimit autocalculated to 40)`
  },
  custody: {
    id: `${i18nKey}.custody`,
    defaultMessage: 'Custody',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Custody product label (CharLimit autocalculated to 40)`
  },
  listings: {
    id: `${i18nKey}.listings`,
    defaultMessage: 'Asset Listings',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Listings page label (CharLimit autocalculated to 40)`
  },
  institutional: {
    id: `${i18nKey}.institutional`,
    defaultMessage: 'Institutional',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Institutional page label (CharLimit autocalculated to 45)`
  },
  wallet: {
    id: `${i18nKey}.wallet`,
    defaultMessage: 'Wallet',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Wallet product label (CharLimit autocalculated to 40)`
  },
  coinbasePaySdk: {
    id: `${i18nKey}.coinbasePaySdk`,
    defaultMessage: 'Coinbase Pay SDK',
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Coinbase Pay SDK label (CharLimit autocalculated to 50)`
  },
  nft: {
    id: `${i18nKey}.nft`,
    defaultMessage: 'NFT',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Coinbase NFT product label (CharLimit autocalculated to 35)`
  },
  card: {
    id: `${i18nKey}.card`,
    defaultMessage: 'Card',
    description: `
    #Component: LEGACY
    #CharLimit: 35
    #Context: Card product label (CharLimit autocalculated to 35)`
  },
  derivatives: {
    id: `${i18nKey}.derivatives`,
    defaultMessage: 'Derivatives Exchange',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: derivatives product label (CharLimit autocalculated to 55)`
  },
  keyDocumentInformation: {
    id: `${i18nKey}.keyDocumentInformation`,
    defaultMessage: 'Key Information Document',
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Link to a document that point out some key information (CharLimit autocalculated to 60)`
  },
  conflictOfInterest: {
    id: `${i18nKey}.conflictOfInterest`,
    defaultMessage: 'Conflict of Interest',
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Link to a document that informs users about the rules of conflict of interest (CharLimit autocalculated to 55)`
  },
  compensationMethod: {
    id: `${i18nKey}.compensationMethod`,
    defaultMessage: 'Statement on the Compensation Method',
    description: `
    #Component: LEGACY
    #CharLimit: 80
    #Context: Link to a document that provides a statement on the Compensation Method (CharLimit autocalculated to 80)`
  },
  statementBestExecution: {
    id: `${i18nKey}.statementBestExecution`,
    defaultMessage: 'Statement of Best Execution',
    description: `
    #Component: LEGACY
    #CharLimit: 65
    #Context: Link to a document that provides a statement of best execution (CharLimit autocalculated to 65)`
  },
  antiSocialForcesPolicy: {
    id: `${i18nKey}.antiSocialForcesPolicy`,
    defaultMessage: 'Policy on Blocking Relationships with Antisocial Forces',
    description: `
    #Component: LEGACY
    #CharLimit: 105
    #Context: Link to a document that informs users the policy on blocking relationships with anti-social forces (CharLimit autocalculated to 105)`
  },
  safetyManagementOfInformationAssets: {
    id: `${i18nKey}.safetyManagementOfInformationAssets`,
    defaultMessage: 'Basic Policy on Safety Management of Information Assets',
    description: `
    #Component: LEGACY
    #CharLimit: 105
    #Context: Link to a document that informs users the basic policy on safety management of information assets (CharLimit autocalculated to 105)`
  },
  systemRiskManagement: {
    id: `${i18nKey}.systemRiskManagement`,
    defaultMessage: 'Basic Policy for System Risk Management',
    description: `
    #Component: LEGACY
    #CharLimit: 80
    #Context: Link to a document that informs users the basic policy for system risk management (CharLimit autocalculated to 80)`
  },
  moneyLaunderingPrevention: {
    id: `${i18nKey}.moneyLaunderingPrevention`,
    defaultMessage: 'Basic Policy on Prevention of Money Laundering and Terrorist Financing',
    description: `
    #Component: LEGACY
    #CharLimit: 125
    #Context: Link to a document that informs users the basic policy on prevention of money laundering and terrorist financing (CharLimit autocalculated to 125)`
  },
  digitalAssetDisclosures: {
    id: `${i18nKey}.digitalAssetDisclosures`,
    defaultMessage: 'Digital Asset Disclosures',
    description: `
    #Component: LEGACY
    #CharLimit: 65
    #Context: Navigation link for Coinbase Digital Asset Disclosures (CharLimit autocalculated to 65)`
  },
  vendors: {
    id: `${i18nKey}.vendors`,
    defaultMessage: 'Vendors',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Navigation link for Vendors (CharLimit autocalculated to 40)`
  },
  coinbaseOne: {
    id: `${i18nKey}.coinbaseOne`,
    defaultMessage: 'Coinbase One',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Navigation link for Coinbase One (CharLimit autocalculated to 45)`
  },
  staking: {
    id: `${i18nKey}.staking`,
    defaultMessage: 'Staking',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Navigation link for Staking`
  },
  exchange: {
    id: `${i18nKey}.exchange`,
    defaultMessage: 'Exchange',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Navigation link for Exchange`
  },
  internationalExchange: {
    id: `${i18nKey}.internationalExchange`,
    defaultMessage: 'International Exchange',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Navigation link for International Exchange`
  },
  verifiedPools: {
    id: `${i18nKey}.verifiedPools`,
    defaultMessage: 'Verified Pools',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Navigation link for Verified Pools`
  }
});
export { messages };
//# sourceMappingURL=navigation.js.map
